import { z } from 'zod';
import { StringOptional } from './schemaTypes';

export const FlightStatusSchema = z.object({
	engineURL: z.string().describe('Адрес страницы с модулем Engine (используется для перехода на FastSearch поиск)'),
	appStoreURL: StringOptional.describe('Ссылка на скачивание приложения (используется в BoardingInfo)'),
	playMarketURL: StringOptional.describe('Ссылка на скачивание приложения (используется в BoardingInfo)'),
	accessToken: z.string().describe('Токен доступа (можно получить в ЛК https://www.mapbox.com/)'),
	starlineAccessToken: z.string(),
	starlineStyleId: z.string(),
	stylesEn: z
		.string()
		.describe('Ссылка на карту с английскими обозначениями (можно получить на https://www.mapbox.com/)'),
	stylesRu: z
		.string()
		.describe('Ссылка на карту с русскими обозначениями (можно получить на https://www.mapbox.com/)')
});
